
import { Box, Container, Typography, Card, CardContent } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ReactComponent as LoginIcon } from "./assets/User-Podcast--Streamline-Plump.svg";
import { ReactComponent as JoinIcon } from "./assets/User-Switch-Account--Streamline-Plump.svg";
import { Link } from "react-router-dom";
import {keycloak} from "./config/auth";

export default function StartPage() {

    return (
        <Container sx={{ mt: 5, mb: 8 }} maxWidth="lg">
            <Box sx={{ position: "relative", pb: "1em"}}>
                <Typography variant="h3" gutterBottom>European Language Data Space</Typography>
                <Typography variant="h4">Participant Registry</Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} sx={{justifyContent: "center"}}>
                    <Grid size={6} style={{display: "flex"}}>
                        <Card style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", width: "100%"}}>
                            <CardContent className="centered">
                                <JoinIcon style={{ width: "20%", paddingTop: "0.5em", paddingBottom: "0.5em", marginRight: "2em" }} />
                                <Link to="/participant-form"><Typography variant="h6">Apply for joining the European Language Data Space</Typography></Link>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={6} style={{display: "flex"}}>
                        <Card style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", width: "100%" }}>
                            <CardContent className="centered">
                                <LoginIcon style={{ width: "20%", paddingTop: "0.5em", paddingBottom: "0.5em", marginRight: "2em" }} />
                                <Link component="button"
                                    onClick={() => {
                                        keycloak.login({
                                            redirectUri: window.location.origin + "/management", // Specify the redirect URI
                                        });
                                    }}
                                >
                                    <Typography variant="h6">Enter the European Language Data Space Participant Registry, if you have already been approved.</Typography>
                                </Link>
                            </CardContent>
                        </Card>

                    </Grid>
                </Grid>
            </Box>

        </Container>
    );
}
